import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import translation from 'translation';


const accountConnectionsRoutes = [
  {
    path: '',
    component: NestedRouteComponent,
    meta: {
      nestedName: 'connections_nested',
      permissions: ['READ_CONNECTIONS']
    },
    children: [
      {
        path: 'connections',
        component: NestedRouteComponent,
        meta: {
          routeName: {
            segmentName: () => translation.tr('Connections')
          }
        },
        children: [
          {
            path: '',
            name: 'connectionsList',
            component: wrapLegacyRoute('oldConnectionsController', 'channelsList')
          },
          {
            path: 'create',
            name: 'connectionCreate',
            component: () => asyncLoadView(import('pages/connections/connections/CreateConnectionPage')),
            props: routeArgsToInt
          },
          {
            path: ':parentConnectionId(\\d+)/subconnection',
            name: 'connectionCreateSubconnection',
            component: () => asyncLoadView(import('pages/connections/connections/CreateSubconnectionPage')),
            props: routeArgsToInt
          },
          {
            path: 'pending/:pendingConnectionId(\\d+)/subconnection',
            name: 'connectionCreatePendingSubconnection',
            component: () => asyncLoadView(import('pages/connections/connections/CreatePendingSubconnectionPage')),
            props: routeArgsToInt
          },
          {
            path: ':connectionId(\\d+)/currency',
            name: 'connectionCurrencySetup',
            component: () => asyncLoadView(import('pages/connections/connections/SetupConnectionCurrencyPage')),
            props: routeArgsToInt
          },
          {
            path: ':connectionId(\\d+)',
            component: NestedRouteComponent,
            children: [
              {
                path: '',
                name: 'connectionDetails',
                component: wrapLegacyRoute('oldConnectionsController', 'details')
              },
              {
                path: 'financialparams',
                name: 'connectionFinancialParams',
                component: wrapLegacyRoute('oldConnectionParamsController', 'financialParams')
              },
              {
                path: 'currencyrates',
                name: 'connectionCurrencyRate',
                component: wrapLegacyRoute('currencyController', 'list')
              },
              {
                path: 'currencyrates/create',
                name: 'connectionCurrencyRateCreate',
                component: wrapLegacyRoute('currencyController', 'create')
              },
              {
                path: 'currencyrates/:currencyRateId(\\d+)/details',
                name: 'connectionCurrencyRateDetails',
                component: wrapLegacyRoute('currencyController', 'details')
              }
            ]
          },
          {
            path: 'create/old',
            name: 'connectionCreateOld',
            component: wrapLegacyRoute('oldConnectionsController', 'create')
          }
        ]
      },
      {
        path: 'webanalytics/connections',
        component: NestedRouteComponent,
        meta: {
          routeName: {
            segmentName: () => translation.tr('Connections')
          }
        },
        children: [
          {
            path: '',
            name: 'webanalyticsConnectionsList',
            component: wrapLegacyRoute('oldConnectionsController', 'webAnalyticsList')
          },
          {
            path: 'create/old',
            name: 'webanalyticsConnectionCreateOld',
            component: wrapLegacyRoute('oldConnectionsController', 'webAnalyticsCreate')
          },
          {
            path: 'create',
            name: 'webanalyticsConnectionCreate',
            component: () => asyncLoadView(import('pages/connections/webanalytics/CreateWebanalyticsConnectionPage')),
            props: routeArgsToInt
          },
          {
            path: ':waConnectionId(\\d+)/setup',
            name: 'webanalyticsConnectionSetup',
            component: () => asyncLoadView(import('pages/connections/webanalytics/WebanalyticsConnectionSetupPage')),
            props: routeArgsToInt
          },
          {
            path: 'pending/:pendingWaConnectionId(\\d+)/setup',
            name: 'webanalyticsPendingConnectionSetup',
            component: () => asyncLoadView(import('pages/connections/webanalytics/PendingWebanalyticsConnectionSetupPage')),
            props: routeArgsToInt
          },
          {
            path: ':waConnectionId(\\d+)',
            component: NestedRouteComponent,
            children: [
              {
                path: 'utm',
                name: 'webAnalyticsConnectionUtms',
                component: wrapLegacyRoute('webAnalyticsController', 'utmConfigure')
              },
              {
                path: 'params',
                name: 'webAnalyticsConnectionParams',
                component: wrapLegacyRoute('webAnalyticsController', 'paramsList')
              },
              {
                path: 'rates',
                name: 'webAnalyticsCurrencyRateList',
                component: wrapLegacyRoute('webAnalyticsController', 'ratesList')
              },
              {
                path: 'rates/create',
                name: 'webAnalyticsCurrencyRateCreate',
                component: wrapLegacyRoute('webAnalyticsController', 'rateCreate')
              },
              {
                path: 'rates/:currencyRateId(\\d+)',
                name: 'webAnalyticsCurrencyRateDetails',
                component: wrapLegacyRoute('webAnalyticsController', 'rateDetails')
              }
            ]
          }
        ]
      }
    ]
  }

];


export default accountConnectionsRoutes;
